import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { formSchema } from '../../../../components/forms/equipment-association-schema';
import AssociationForm from '../../../../components/forms/equipment-association-form';
import { useFvsRequirements } from '../requirements-provider';
import { determineUpdatableFields } from '../../../../components/forms/association-specification-fields';

const EquipmentCodeAssociationEdit = () => {
  const {
    equipmentAssociation,
    lookupCodesUngrouped,
    updateEquipmentAssociation,
  } = useFvsRequirements();

  const {
    formState: { errors },
    control,
    handleSubmit,
    register,
    setValue,
  } = useForm({
    resolver: yupResolver(formSchema),
    reValidateMode: 'onChange',
  });

  const onSubmit = (data) => {
    const { id, standardItemId, equipmentCodeId } = equipmentAssociation;

    const updatableFields = determineUpdatableFields(data);

    updateEquipmentAssociation({
      variables: {
        id: Number(id),
        equipmentAssociation: {
          standardItemId,
          equipmentCodeId,
          ...updatableFields,
        },
      },
    });
  };

  return (
    <form id="equipment-code-edit-form" onSubmit={handleSubmit(onSubmit)}>
      <AssociationForm
        control={control}
        setValue={setValue}
        errors={errors}
        register={register}
        updateEquipmentCodeId={() => {
          // TODO
        }}
        equipmentCodeId="0"
        equipmentAssociation={equipmentAssociation}
        multipleOptions={lookupCodesUngrouped}
      />
    </form>
  );
};

export default EquipmentCodeAssociationEdit;
